
import React from 'react';
import { Link } from 'react-router-dom';
import { SyncratikLogo } from '../common/SyncratikLogo';


const Footer = () => {
    return (
        <footer className="bg-gray-15 text-gray-95 relative z-10">
            <div className="container-wide py-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                    {/* Company Info - Left side */}
                    <div className="md:col-span-5">
                        <div className="flex items-center space-x-2 mb-4">
                            <SyncratikLogo className="h-8 w-8" />
                            <h3 className="text-lg font-sansation text-gray-95 tracking-wide">SYNCRATIK</h3>
                        </div>
                        <p className="text-gray-70 text-paragraph leading-relaxed max-w-sm mb-5">
                            Syncratik makes tailored turnkey AI solutions effortlessly accessible for every business and individual.
                        </p>
                        <div className="text-paragraph text-gray-70">
                            <p>8732 Orwell Avenue,</p>
                            <p>Westminster, CA 92683</p>
                            <p className="my-2">info@syncratik.com</p>
                            <p>+1 (213) 695-0908</p>
                        </div>
                    </div>

                    {/* Company Links */}
                    <div className="md:col-span-2 md:col-start-7">
                        <h4 className="text-gray-50 text-paragraph mb-4">Company</h4>
                        <ul>
                            <li className="mb-3"><Link to="/about" className="text-gray-70 hover:text-gray-95 text-paragraph transition duration-300">About</Link></li>
                            <li className="mb-3"><Link to="/pricing" className="text-gray-70 hover:text-gray-95 text-paragraph transition duration-300">Pricing</Link></li>
                            <li className="mb-3"><Link to="/news" className="text-gray-70 hover:text-gray-95 text-paragraph transition duration-300">News</Link></li>
                            <li><Link to="/contact" className="text-gray-70 hover:text-gray-95 text-paragraph transition duration-300">Talk to Us</Link></li>
                        </ul>
                    </div>

                    {/* Legal Links */}
                    <div className="md:col-span-2">
                        <h4 className="text-gray-50 text-paragraph mb-4">Legal</h4>
                        <ul>
                            <li className="mb-3"><Link to="/privacy" className="text-gray-70 hover:text-gray-95 text-paragraph transition duration-300">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="text-gray-70 hover:text-gray-95 text-paragraph transition duration-300">Terms of Service</Link></li>
                        </ul>
                    </div>

                    {/* Social Icons - Top right */}
                    <div className="md:col-span-2 flex md:justify-end items-start">
                        <div className="flex space-x-4">
                            <a href="https://www.linkedin.com/company/syncratik" target="_blank" rel="noopener noreferrer" className="w-6 h-6 text-gray-70 rounded-sm flex items-center justify-center hover:text-gray-95 transition duration-300">
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                </svg>
                            </a>
                            <a href="https://www.facebook.com/people/Syncratik/61580013316849/" target="_blank" rel="noopener noreferrer" className="w-6 h-6 rounded-sm flex items-center justify-center text-gray-70 hover:text-gray-95 transition duration-300">
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                            </a>
                            <a href="https://youtube.com/@syncratik" target="_blank" rel="noopener noreferrer" className="w-6 h-6 rounded-sm flex items-center justify-center text-gray-70 hover:text-gray-95 transition duration-300">
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                </svg>
                            </a>
                            <a href="https://x.com/syncratikai" target="_blank" rel="noopener noreferrer" className="w-6 h-6 rounded-sm flex items-center justify-center text-gray-70 hover:text-gray-95 transition duration-300">
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-gray-30 mt-10 pt-10">
                    <p className="text-gray-50 text-paragraph">
                        © 2026 Syncratik. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
